/*
 * Constants.
 */

const emojiBaseUrl = 'https://assets.frontapp.com/emoji-data-13.1';
export const emojiSheetUrl = `${emojiBaseUrl}/sheet_apple_64_indexed_256.png`;
export const emojiUrl = `${emojiBaseUrl}/img-apple-64/`;
